import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { FC } from "react";

interface QuarterFilterProps {
  testIdPrefix: string; // Used for the testId
  onSelectQuarterChange: (selectedQuarter: string) => void;
  selectedQuarter: string;
  options: Array<{ key: string, value: string }>;
}

const SelectQuarterFilter: FC<QuarterFilterProps> = (props: QuarterFilterProps) => {
  return (
    <>
      <p className="lead mb0 demibold">Outreach Date Range Filter</p>
      <div className="form-group row">
        <div className="col-lg-12">
          <QESSelect
            containerClassName="mb-0"
            label="Please select summary range to include:"
            onChange={(e) => props.onSelectQuarterChange(e.target.value as string)}
            testId={`outreach-export-${props.testIdPrefix}__date-range-select`}
            value={props.selectedQuarter}
          >
            {
              props.options.map(({ key, value }) => (
                <option key={key} value={key}>{value}</option>
              ))}
          </QESSelect>
        </div>
      </div>
    </>
  );
}

export default SelectQuarterFilter;
